import { IntlShape, defineMessages } from 'react-intl'
import * as yup from 'yup'

import { INewPartnerData } from 'features/Partners/types'

const nameMessages = defineMessages({
  required: {
    id: 'partners.new.name.required',
    defaultMessage: 'The partner name is required'
  },
  max: {
    id: 'partners.new.name.max',
    defaultMessage: 'The partner name must be at most {max} characters'
  }
})

const partnerTypeMessages = defineMessages({
  required: {
    id: 'partners.new.type.required',
    defaultMessage: 'The partner type is required'
  }
})

const verticalsMessages = defineMessages({
  min: {
    id: 'partners.new.verticals.min',
    defaultMessage: 'Select at least one vertical'
  }
})

export const schema = (intl: IntlShape): yup.SchemaOf<INewPartnerData> => {
  return yup.object().shape({
    name: yup
      .string()
      .max(128, ({ max }) => intl.formatMessage(nameMessages.max, { max }))
      .required(intl.formatMessage(nameMessages.required)),
    city: yup.object().shape({
      id: yup.string(),
      name: yup.string(),
      stateCode: yup.string()
    }),
    state: yup.object().shape({
      code: yup.string(),
      name: yup.string()
    }),
    operationalStates: yup.array().of(
      yup.object().shape({
        code: yup.string().required(),
        name: yup.string().required()
      })
    ),
    type: yup.mixed().required(intl.formatMessage(partnerTypeMessages.required)),
    verticals: yup.array().of(yup.mixed().required()).min(1, intl.formatMessage(verticalsMessages.min))
  })
}
